import React, { useState } from 'react';
import { Button, Flex, TextArea, Typography } from '../common';
import { TYPOGRAPHY } from '../../constants';
import { useNavigate } from 'react-router-dom';
import { saveFeedback } from '../../api';
import { useForm } from 'antd/es/form/Form';
import { Form, message } from 'antd';

function Feedback() {
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState('');
  const [feedbackText, setFeedbackText] = useState('');
  const [loading, setLoading] = useState(false);
  const [form] = useForm();

  const handleRadioChange = (event) => {
    setSelectedValue(Number(event.target.value));
  };

  const handleFeedbackChange = (event) => {
    setFeedbackText(event.target.value);
  };

  const handleSendFeedback = async () => {
    if (!selectedValue) {
      message.error('Please select a rating.');
      return;
    }

    setLoading(true);
    try {
      const response = await saveFeedback(feedbackText, selectedValue);
      setSelectedValue(null);
      setFeedbackText('');
      message.success(response.data.message);
    } catch (error) {
      console.error('Error saving feedback:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form form={form} className=" h-full">
      <Flex
        vertical
        className="h-full min-h-[calc(100vh-12rem)] justify-between"
      >
        <Flex vertical className=" pt-10 gap-6">
          <Typography text="Feedback" type={TYPOGRAPHY.TITLE} />
          <Flex
            vertical
            gap={30}
            className="py-3 px-4 cursor-pointer max-w-[500px] items-center"
          >
            <Typography
              text="How likely are you to recommend SurpassIn?"
              className="!text-teal-400 text-center mx-auto !font-semibold"
              type={TYPOGRAPHY.PARA}
            />
            <Flex className="gap-4">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((number) => (
                <Flex key={number} className="items-center gap-2">
                  <input
                    type="radio"
                    id={`radio-${number}`}
                    name="recommendation"
                    value={number}
                    checked={selectedValue === number}
                    onChange={handleRadioChange}
                    className="form-radio h-4 w-4 text-teal-600 hidden"
                  />
                  <label
                    htmlFor={`radio-${number}`}
                    className={`cursor-pointer flex justify-center font-semibold items-center border-[1px] w-6 h-6 border-purple-600 rounded-full ${
                      selectedValue === number
                        ? 'bg-purple-600 text-white'
                        : '!text-purple-600'
                    }`}
                  >
                    {number}
                  </label>
                </Flex>
              ))}
            </Flex>
            <Flex justify="space-between" className="w-full">
              <Typography text="0 - Not at all likely" type={TYPOGRAPHY.PARA} />
              <Typography text="10 - Extremely likely" type={TYPOGRAPHY.PARA} />
            </Flex>
          </Flex>
          <Flex vertical gap={10} className="!max-w-[500px]">
            <Typography
              // text="Do you have any feedback for how we can improve SurpassIn?"
              text=" Do you have any feedback for how we can improve SurpassIn? For example, what features can we add to improve it for you and other users?"
              type={TYPOGRAPHY.PARA}
              className="!font-semibold"
            />
            <TextArea
              value={feedbackText}
              {...{
                formItemProps: {
                  name: '',
                  required: false,
                },
                textareaProps: {
                  placeholder: 'We’d love to hear your suggestions',
                  type: 'textarea',
                  rows: 3,
                  maxLength: 400,
                },
              }}
              onChange={handleFeedbackChange}
            />
            <Flex
              justify="end"
              className="-mt-4 md:-mt-6 text-xs md:text-sm text-teal-500"
            >
              {feedbackText.length} / 400 Characters
            </Flex>
          </Flex>
        </Flex>
        <Flex
          vertical
          justify="space-between"
          className=" w-full text-white mt-auto "
        >
          <Flex
            justify="end"
            className={`sticky bottom-0 w-full  lg:justify-between justify-end  p-4 border-t h-[56px] md:h-[72px] border-[#7C30F7]  bg-primaryLight `}
          >
            <Button
              text="Back"
              onClick={() => {
                navigate(-1);
              }}
              buttonProps={{ type: 'primary-none' }}
            />
            <Button
              text={'Send Feedback'}
              onClick={handleSendFeedback}
              loadingData={loading}
              buttonProps={{ type: 'primary-square' }}
            />
          </Flex>
        </Flex>
      </Flex>
    </Form>
  );
}

export default Feedback;
